module.exports = __webpack_public_path__ + "static/media/developerActivity.bbc47f05.svg";